import { useState } from 'react';
import { toonAantal } from '@boodschappenlijst/shared';
import type { ItemMetSamenvoegingen } from './items.api';

export type Filter = 'open' | 'gedaan' | 'alles';

interface Props {
  items: ItemMetSamenvoegingen[];
  filter: Filter;
  onFilter: (f: Filter) => void;
  onToggle: (id: string) => void;
  onVerwijder: (id: string) => void;
  onWisGedaan: () => void;
}

const FILTERS: { waarde: Filter; label: string }[] = [
  { waarde: 'open', label: 'Open' },
  { waarde: 'gedaan', label: 'Klaar' },
  { waarde: 'alles', label: 'Alles' },
];

export function BoodschappenLijst({
  items,
  filter,
  onFilter,
  onToggle,
  onVerwijder,
  onWisGedaan,
}: Props) {
  const [wisBevestiging, setWisBevestiging] = useState(false);

  const zichtbaar = items.filter((i) =>
    filter === 'alles' ? true : filter === 'open' ? !i.gedaan : i.gedaan,
  );
  const aantalGedaan = items.filter((i) => i.gedaan).length;

  return (
    <section>
      <h2 className="vs-section-title">Boodschappenlijst</h2>

      <div className="vs-filters">
        {FILTERS.map((f) => (
          <button
            key={f.waarde}
            className="vs-filter"
            aria-pressed={filter === f.waarde}
            onClick={() => onFilter(f.waarde)}
          >
            {f.label}
          </button>
        ))}
        {aantalGedaan > 0 && (
          <button
            className="vs-btn vs-btn--danger vs-btn--sm"
            style={{ marginLeft: 'auto' }}
            onClick={() => setWisBevestiging(true)}
          >
            Wis {aantalGedaan} afgevinkt{aantalGedaan === 1 ? 'e' : 'e'}
          </button>
        )}
      </div>

      <div className="vs-card" style={{ padding: 'var(--space-2)' }}>
        {zichtbaar.length === 0 ? (
          <p className="vs-empty">
            {filter === 'gedaan' ? 'Nog niets afgevinkt.' : 'De lijst is leeg.'}
          </p>
        ) : (
          <ul className="vs-list">
            {zichtbaar.map((item) => (
              <li key={item.id} className={`vs-row${item.gedaan ? ' vs-row--gedaan' : ''}`}>
                <input
                  type="checkbox"
                  className="vs-row__check"
                  checked={item.gedaan}
                  onChange={() => onToggle(item.id)}
                  aria-label={`${item.naam} afvinken`}
                />
                <div className="vs-row__body">
                  <div className="vs-row__naam">
                    {item.naam}
                    {item.uitVoorraad && <span className="vs-badge">uit voorraad</span>}
                  </div>
                  <div className="vs-row__meta">
                    {item.toegevoegdDoor}
                    {item.samenvoegingen.length > 0 &&
                      ` · ook gevraagd door ${item.samenvoegingen.map((s) => s.door).join(', ')}`}
                  </div>
                </div>
                <span className="vs-row__aantal">{toonAantal(item.aantal, item.eenheid)}</span>
                <button
                  className="vs-icon-btn"
                  onClick={() => onVerwijder(item.id)}
                  aria-label={`${item.naam} verwijderen`}
                  title="Verwijderen"
                >
                  ✕
                </button>
              </li>
            ))}
          </ul>
        )}
      </div>

      {wisBevestiging && (
        <div className="vs-overlay" role="dialog" aria-modal="true" aria-labelledby="wis-titel">
          <div className="vs-card vs-dialog">
            <h2 className="vs-dialog__title" id="wis-titel">
              Afgevinkte regels wissen?
            </h2>
            <p className="vs-dialog__body">
              {aantalGedaan} afgevinkte {aantalGedaan === 1 ? 'regel wordt' : 'regels worden'}{' '}
              verwijderd. Dit kan niet ongedaan worden gemaakt.
            </p>
            <div className="vs-dialog__actions">
              <button className="vs-btn vs-btn--ghost" onClick={() => setWisBevestiging(false)}>
                Annuleren
              </button>
              <button
                className="vs-btn vs-btn--danger"
                onClick={() => {
                  setWisBevestiging(false);
                  onWisGedaan();
                }}
              >
                Wissen
              </button>
            </div>
          </div>
        </div>
      )}
    </section>
  );
}
